module.exports = __webpack_public_path__ + "img/login.99da7e4e.svg";